<delab-ngx-title-page>
    <div class="flex grow items-center justify-end gap-2">
        <a mat-button [href]="RELEASE_NOTES_URL" target="_blank" color="primary" value="Release-Notes">Release-Notes anzeigen</a>
        <a mat-flat-button [href]="this.mailtoLink()" color="primary">Hilfe-Email versenden</a>
    </div>
</delab-ngx-title-page>

<h2 class="mb-4 text-xl font-bold">{{ this.APP_NAME }}</h2>

@for (info of this.infos(); track info.label) {
    <p [ngClass]="{ 'mb-2': !$last }">
        <span class="font-medium">{{ info.label }}:</span> {{ info.value || '---' }}
    </p>
}
